import CatalogueProducts from './CatalogueProducts';

export default CatalogueProducts;
